<sm-title-bar
  pageTitle="{{ 'onlinepayments.title' | translate }}"
  [backWithParams]="true"
>
</sm-title-bar>

<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="openexistingaccount()">
    <mat-icon>assignment_add</mat-icon>
    <span class="menu_text">Add existing account</span>
  </button>
  <button mat-menu-item (click)="openconfigureDiscount()">
    <mat-icon>playlist_add</mat-icon>
    <span class="menu_text">Add new account</span>
  </button>
</mat-menu>

<div class="merchant_detail_sec" *ngIf="isEntityForeign == '0'">
  <div class="mrt_offe">
    <div class="row">
      <div class="col-sm-12">
        <div class="drt_head"></div>
        <div class="list_user" *ngIf="loader == false">
          <a href="javascript:void(0)" class="admin_category">
            <div class="card_header chead">
              <div class="adm_set">
                <div>
                  <span class="name_cont">Payment status</span>
                  <mat-slide-toggle
                    class="share"
                    (change)="onToggleChange($event)"
                    [checked]="toShowCheck === 1"
                  ></mat-slide-toggle>
                  <h2
                    style="
                      color: #666666;
                      padding-top: 0px;
                      margin-top: 2px;
                      margin-bottom: 8px;
                      font-size: 14px;
                    "
                    *ngIf="toShowCheck === 1"
                  >
                    Online payment enabled.
                  </h2>
                  <h2
                    style="
                      color: #666666;
                      padding-top: 0px;
                      margin-top: 2px;
                      margin-bottom: 8px;
                      font-size: 14px;
                    "
                    *ngIf="toShowCheck === 0"
                  >
                    Online payment disabled.
                  </h2>

                  <div class="row">
                    <div class="col-sm-9">
                      <h4 style="margin-bottom: 8px">
                        With online payment enabled, your customers can be able to pay for the bookings and membership from the app or website. The payments will be transferred to your bank account directly. This will happen automatically. You just need to add a new Razorpay account or link an existing one with your business. If you are new to Razorpay, you can sign-up while in the process.
                      </h4>

                      <!-- <h4>
                        You can also set the refund threshold below. Customer
                        can claim for a refund within that period. The refund
                        claim and the actual refund is a subject matter between
                        you and the customer.
                      </h4> -->

                      <!-- <h4>With online payment enabled, your customers can be able to pay for the bookings and membership from the app or website. The payments will be transferred to your bank account directly. This will happen automatically. You just need to add a valid bank account here.</h4> -->
                    </div>
                    <div class="col-sm-3">
                      <div class="img_online_logo">
                        <a href="https://razorpay.com/" target="_blank">
                          <img
                            referrerpolicy="origin"
                            src="https://badges.razorpay.com/badge-light.png "
                            style="
                              height: 65px;
                              width: 180px;
                              border-radius: 0px !important;
                              object-fit: initial;
                            "
                            alt="Razorpay | Payment Gateway | Neobank"
                        /></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- (click)="configureDiscount()" -->

              <!-- (click)="openconfigureDiscount()" -->
              <!-- <div class="create_btn_sd" *ngIf="toShowCheck === 1" >
                <button mat-button aria-label="option menu"  color="accent"  (click)="openconfigureDiscount()">
                  Configure online payment
                </button>
            </div> -->
              <!-- Paypal get stated section start -->
              <div
                class="paypal-checkout"
                *ngIf="
                  toShowCheck === 1 &&
                  (!onlinePaymentsData[0]?.razorpay_account_id ||
                    onlinePaymentsData[0]?.razorpay_account_id == 'null' ||
                    onlinePaymentsData[0]?.razorpay_account_id == '')
                "
              >
                <div class="row align-items-center">
                  <div class="col-sm-8">
                    <div class="befefits_headding">
                      <h3>Benefits and other info</h3>
                    </div>
                    <ul class="paypal-features">
                      <li>
                        Enable customers to pay with their Razorpay and digital
                        wallets with no setup or monthly fees.
                      </li>
                      <li>
                        Provide buy now pay later solutions at no extra cost.
                      </li>
                      <li>
                        Accept major credit/debit cards and local payment
                        methods through the wallet.
                      </li>
                      <li>
                        If you haven't linked any business with Razorpay in
                        LookzUp yet, start with 'Get started' button.
                      </li>
                      <li>
                        Click 'Link an account' to use your existing Razorpay
                        account in LookzUp for this business.
                      </li>
                    </ul>
                    <div class="same_btn_added">
                      <div class="paypal-footer">
                        <button
                          class="btn-get-started"
                          (click)="createRazorPaySubMerchantAccount()"
                        >
                          Get started
                        </button>
                      </div>
                      <div class="link-footer">
                        <button
                          class="un-link"
                          (click)="openexistingaccount()"
                          *ngIf="
                            !onlinePaymentsData[0]?.razorpay_account_id ||
                            onlinePaymentsData[0]?.razorpay_account_id ==
                              'null' ||
                            onlinePaymentsData[0]?.razorpay_account_id == ''
                          "
                        >
                          Link an account
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Paypal get stated section end -->

              <!-- Paypal Checkout section start -->
              <div
                class="paypal-checkout"
                *ngIf="
                  toShowCheck === 1 &&
                  onlinePaymentsData[0]?.razorpay_account_id &&
                    onlinePaymentsData[0]?.razorpay_account_id != 'null' &&
                    onlinePaymentsData[0]?.razorpay_account_id != ''
                "
              >
                <div class="row">
                  <div class="col-sm-8">
                    <div class="befefits_headding">
                      <h3>You are ready for Razorpay.</h3>
                    </div>
                    <!-- <p>Login e-mail: <span style="font-weight: 600;"> {{onlinePaymentsData[0]?.email}}</span></p> -->
                    <p>
                      Razorpay account ID:
                      <span style="font-weight: 600">
                        {{ onlinePaymentsData[0]?.razorpay_account_id }}</span
                      >
                    </p>
                    <p>
                      Account linked on:
                      <span style="font-weight: 600">
                        {{ onlinePaymentsData[0]?.creation_time | date }}</span
                      >
                    </p>
                    <ul class="paypal-features checkoutxc">
        <li *ngIf="onlinePaymentsData[0]?.payments_receivable == true"><mat-icon>check</mat-icon> Your Razorpay account is connected.</li>
        <li *ngIf="onlinePaymentsData[0]?.payments_receivable == false"><mat-icon style="color: red;">close</mat-icon> Your Razorpay account is not connected.</li>
       
      </ul>
                    <div class="paypal-footer">
                      <button
                        class="btn-get-started"
                        *ngIf="onlinePaymentsData[0]?.is_primary == 1"
                        (click)="openDomesticsettings()"
                      >
                        Settings
                      </button>
                      <button class="un-link" (click)="unLink()">
                        Un-link account
                      </button>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="paynt_sert">
                      <!-- <div class="sync_btn">
           <button (click)="sync()"><mat-icon>refresh</mat-icon> Sync with PayPal</button>
        </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
      <!-- <div class="col-sm-1"></div> -->
    </div>
  </div>
</div>

<!-- nooo internatinal -->
<div class="merchant_detail_sec" *ngIf="isEntityForeign == '1'">
  <div class="mrt_offe">
    <div class="row">
      <div class="col-sm-12">
        <div class="drt_head"></div>
        <div class="list_user" *ngIf="loader == false">
          <div class="admin_category">
            <div class="card_header chead">
              <div class="adm_set">
                <div>
                  <span class="name_cont">Payment status</span>
                  <mat-slide-toggle
                    class="share"
                    (change)="onToggleChangeForInternational($event)"
                    [checked]="toShowCheckForInternational === 1"
                  ></mat-slide-toggle>
                  <h2
                    style="
                      color: #666666;
                      padding-top: 0px;
                      margin-top: 2px;
                      margin-bottom: 8px;
                      font-size: 14px;
                    "
                    *ngIf="toShowCheckForInternational === 1"
                  >
                    Online payment enabled.
                  </h2>
                  <h2
                    *ngIf="toShowCheckForInternational === 0"
                    style="
                      color: #666666;
                      padding-top: 0px;
                      margin-top: 2px;
                      margin-bottom: 8px;
                      font-size: 14px;
                    "
                  >
                    Online payment disabled.
                  </h2>
                  <div class="online_payment_relees">
                    <div class="row align-items-center">
                      <div class="col-sm-8">
                        <h4 style="margin-bottom: 8px">
                          With online payment enabled, your customers can be able to pay for the bookings and membership from the app or website. The payments will be transferred to your bank account directly. This will happen automatically. You just need to add a new PayPal account or link an existing one with your business. If you are new to PayPal, you can sign-up while in the process.
                        </h4>
                      </div>

                      <div class="col-sm-4">
                        <div class="payment-icons">
                          <table
                            style="display: flex; justify-content: center"
                            border="0"
                            cellpadding="10"
                            cellspacing="0"
                            align="center"
                          >
                            <tr>
                              <td align="center">
                                <a
                                  href="https://paypal.com"
                                  target="_blank"
                                  title="How PayPal Works"
                                  ><img
                                    src="https://www.paypalobjects.com/webstatic/mktg/logo/AM_mc_vs_dc_ae.jpg"
                                    border="0"
                                    alt="PayPal Acceptance Mark"
                                /></a>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Paypal get stated section start -->
              <div
                class="paypal-checkout"
                *ngIf="
                  toShowCheckForInternational === 1 &&
                  (!internationalOnlinePaymentsData[0]?.paypal_merchant_id ||
                    internationalOnlinePaymentsData[0]?.paypal_merchant_id ==
                      'null' ||
                    internationalOnlinePaymentsData[0]?.paypal_merchant_id ==
                      '')
                "
              >
                <div class="row align-items-center">
                  <div class="col-sm-8">
                    <div class="befefits_headding">
                      <h3>Benefits and other info</h3>
                    </div>
                    <ul class="paypal-features">
                      <li>
                        Enable customers to pay with their PayPal and Venmo
                        digital wallets with no setup or monthly fees.
                      </li>
                      <li>
                        Provide buy now pay later solutions at no extra cost.
                      </li>
                      <li>
                        Accept major credit/debit cards and local payment
                        methods through the PayPal wallet.
                      </li>
                      <li>
                        If you haven't linked any business with PayPal in
                        LookzUp yet, start with 'Get started' button.
                      </li>
                      <li>
                        Click 'Link an account' to use your existing PayPal
                        account in LookzUp for this business.
                      </li>
                    </ul>
                    <div class="same_btn_added">
                      <div class="paypal-footer">
                        <button
                          class="btn-get-started"
                          (click)="createPaypalPartnerAccount()"
                        >
                          Get started
                        </button>
                      </div>
                      <div class="link-footer">
                        <button
                          class="un-link"
                          (click)="openexistingaccountForInternational()"
                          *ngIf="
                            !internationalOnlinePaymentsData[0]
                              ?.paypal_merchant_id ||
                            internationalOnlinePaymentsData[0]
                              ?.paypal_merchant_id == 'null' ||
                            internationalOnlinePaymentsData[0]
                              ?.paypal_merchant_id == ''
                          "
                        >
                          Link an account
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="col-sm-4">
      <div class="paynt_sert">
      <div class="paypal-header">
       <table border="0" cellpadding="10" cellspacing="0" align="center"><tr><td align="center"><a href="/digital-wallet/ways-to-pay/add-payment-method" title="How PayPal Works" onclick="javascript:window.open('/digital-wallet/ways-to-pay/add-payment-method','WIPaypal','toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=1060, height=700'); return false;"><img src="https://www.paypalobjects.com/webstatic/mktg/logo/pp_cc_mark_74x46.jpg" border="0" alt="PayPal Logo"></a></td></tr></table>
      </div>
          <div class="payment-icons">
         <table border="0" cellpadding="10" cellspacing="0" align="center"><tr><td align="center"><a href="/digital-wallet/ways-to-pay/add-payment-method" title="How PayPal Works" onclick="javascript:window.open('/digital-wallet/ways-to-pay/add-payment-method','WIPaypal','toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=1060, height=700'); return false;"><img src="https://www.paypalobjects.com/webstatic/mktg/logo/AM_mc_vs_dc_ae.jpg" border="0" alt="PayPal Acceptance Mark"></a></td></tr></table>
      </div>
      </div>
      </div> -->
                </div>
              </div>
              <!-- Paypal get stated section end -->

              <!-- Paypal Checkout section start -->
              <div
                class="paypal-checkout"
                *ngIf="
                  toShowCheckForInternational === 1 &&
                  internationalOnlinePaymentsData[0]?.paypal_merchant_id &&
                    internationalOnlinePaymentsData[0]?.paypal_merchant_id !=
                      'null' &&
                    internationalOnlinePaymentsData[0]?.paypal_merchant_id != ''
                "
              >
                <div class="row">
                  <div class="col-sm-8">
                    <div class="befefits_headding">
                      <h3>You are ready for PayPal.</h3>
                    </div>
                    <p>
                      Login e-mail:
                      <span style="font-weight: 600">
                        {{ internationalOnlinePaymentsData[0]?.email }}</span
                      >
                    </p>
                    <p>
                      Merchant ID:
                      <span style="font-weight: 600">
                        {{
                          internationalOnlinePaymentsData[0]?.paypal_merchant_id
                        }}</span
                      >
                    </p>
                    <ul class="paypal-features checkoutxc">
                      <li
                        *ngIf="
                          internationalOnlinePaymentsData[0]
                            ?.payments_receivable == true
                        "
                      >
                        <mat-icon>check</mat-icon> Your PayPal account is
                        connected.
                      </li>
                      <li
                        *ngIf="
                          internationalOnlinePaymentsData[0]
                            ?.payments_receivable == false
                        "
                      >
                        <mat-icon style="color: red">close</mat-icon> Your
                        PayPal account is not connected.
                      </li>
                      <li
                        *ngIf="
                          internationalOnlinePaymentsData[0]
                            ?.primary_email_confirmed == true
                        "
                      >
                        <mat-icon>check</mat-icon> Your business E-mail is
                        verified.
                      </li>
                      <li
                        *ngIf="
                          internationalOnlinePaymentsData[0]
                            ?.primary_email_confirmed == false
                        "
                      >
                        <mat-icon style="color: red">close</mat-icon> Your
                        business E-mail is un-verified.
                      </li>
                    </ul>
                    <div class="paypal-footer">
                      <button
                        (click)="opensettings()"
                        class="btn-get-started"
                        *ngIf="
                          internationalOnlinePaymentsData[0]?.is_primary == 1
                        "
                      >
                        Settings
                      </button>
                      <button class="un-link" (click)="unLinkInternational()">
                        Un-link account
                      </button>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="paynt_sert">
                      <div class="sync_btn">
                        <button (click)="sync()">
                          <mat-icon>refresh</mat-icon> Sync with PayPal
                        </button>
                      </div>
                      <!-- <div class="paypal-header">
     <table border="0" cellpadding="10" cellspacing="0" align="center"><tr><td align="center"><a href="/digital-wallet/ways-to-pay/add-payment-method" title="How PayPal Works" onclick="javascript:window.open('/digital-wallet/ways-to-pay/add-payment-method','WIPaypal','toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=1060, height=700'); return false;"><img src="https://www.paypalobjects.com/webstatic/mktg/logo/pp_cc_mark_74x46.jpg" border="0" alt="PayPal Logo"></a></td></tr></table>
      </div> -->
                      <!-- <div class="payment-icons">
       <table border="0" cellpadding="10" cellspacing="0" align="center"><tr><td align="center"><a href="/digital-wallet/ways-to-pay/add-payment-method" title="How PayPal Works" onclick="javascript:window.open('/digital-wallet/ways-to-pay/add-payment-method','WIPaypal','toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=1060, height=700'); return false;"><img src="https://www.paypalobjects.com/webstatic/mktg/logo/AM_mc_vs_dc_ae.jpg" border="0" alt="PayPal Acceptance Mark"></a></td></tr></table>
      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- nooo internatinal -->
<!-- <div class="merchant_detail_sec"  *ngIf="isEntityForeign=='1'">
  <div class="mrt_offe">
    <div class="row">
      <div class="col-sm-12">
        <div class="drt_head">
        </div>
        <div class="list_user" *ngIf="loader == false">
          <a href="javascript:void(0)" class="admin_category">
            <div class="card_header chead">
              <div class="adm_set">
                <div>
                  <span class="name_cont">Payment status</span>
                  <h2 style="color: #666666;
                  padding-top: 0px;
                  margin-top: 2px;
                  margin-bottom: 8px;
                  font-size: 14px;">Online payment disabled.</h2>
                  <h4 style="margin-bottom: 8px;">
                    With online payment enabled, your customers can be able to pay for the bookings and membership from the app or website. The payments will be transferred to your bank account directly. This will happen automatically. You just need to add a valid bank account here.

                  </h4>
          
                  <h4 style="font-weight: 600;">
                    <mat-icon style="position: relative; top: 7px;">info</mat-icon>
                    Online payments by customers for your services is not available in this region now. Coming soon in next release.
                  </h4>
                </div>
              </div>
            </div>

          </a>


        </div>
      </div>
    </div>
  </div>

</div> -->
